import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Button, Grid, Box, TextField } from '@mui/material';
import MobileDetect from 'mobile-detect';
import WatchIcon from '@mui/icons-material/Watch';
import {getGrupos, getFilters, getInmuebles, getNodos} from '../../store/fuse/filter';
import SearchInput from './searchInput';

const DashboardFilter = ({ currentFilters, filtersSetters, filtersSelected, setFilters, fetchAllData, view }) => {
  const API_URL = process.env.REACT_APP_API_URL;
  const md = new MobileDetect(window.navigator.userAgent);
  const dispatch = useDispatch();
  const initDashboardFilters = () => dispatch(getFilters());
  const { inmuebles, grupos, regiones, nodos } = useSelector((state) => state?.fuse?.filter?.filter?.filters);
  const darkMode = useSelector((state) => state?.fuse?.dashboard?.darkMode);

  const [filtersToApply, setFiltersToApply] = useState({});

  const { inmueble, region, grupo, nodo, dateInit, dateEnd } = currentFilters;
  const { setInmueble, setRegion, setGrupo, setNodo, setDateInit, setDateEnd } = filtersSetters;

  useEffect(() => {
    // dispatch(setFilters({}, null));
    initDashboardFilters();
  }, []);

  useEffect(() => {
    if (region) {
      setGrupo('')
      setInmueble('')
      setNodo('')
      dispatch(getGrupos(region,regiones))
    }
  }, [region]);

  useEffect(() => {
      if (grupo) {
        setInmueble('')
        setNodo('')
        dispatch(getInmuebles(region, grupo, regiones, grupos))
      }
  }, [grupo]);
  
  useEffect(() => {
    if (inmueble) {
      setNodo('')
      dispatch(getNodos(region, grupo, inmueble, regiones, grupos, inmuebles))
    }
  }, [inmueble]);
  
  const handleFilterSelected = (filterCategory, filterToAdd) => {
    let filterValue;
    if (filterCategory === 'region') {
      setRegion(filterToAdd);
      filterValue = filterToAdd;
    } else if (filterCategory === 'inmueble') {
      setInmueble(filterToAdd);
      filterValue = filterToAdd;
    } else if (filterCategory === 'grupo') {
      setGrupo(filterToAdd);
      filterValue = filterToAdd;
    } else if (filterCategory === 'nodo') {
      setNodo(filterToAdd);
      filterValue = String(filterToAdd);
    } else {
      filterValue = filterToAdd;
    }
    setFiltersToApply({ ...filtersToApply, [filterCategory]: filterValue });
  };

  const handleApplyFilters = () => {
    dispatch(setFilters({ ...filtersToApply }));
  };

  const handleClearFilters = () => {
    setRegion('');
    setInmueble('');
    setGrupo('');
    setNodo('');
    setDateInit();
    setDateEnd();
    setFiltersToApply({});
    dispatch(setFilters({}, null));
    initDashboardFilters()
  };

  return (
    <Grid container className="rounded-lg mb-8 ml-9 p-10" style={{ width: '99%', backgroundColor: darkMode ? 'rgb(17, 24, 39)' : 'white' }}>
      {view === 'node-details' && (!md.mobile() || !md.tablet()) && (
        <Grid item xs={12} sm={12} md={5} lg={5} className="flex flex-row justify-start align-middle filter-input-container" />
      )}

      {view !== 'node-details' && (
        <>
          <Grid item xs={12} sm={12} md={1} lg={1} className="flex flex-row justify-start align-middle filter-input-container">
            <SearchInput
              label="Región"
              category="region"
              value={region}
              selectValues={regiones}
              valueKey="dsRegion"
              idKey="regionId"
              handleFilterSelected={handleFilterSelected}
            />
          </Grid>

          <Grid item xs={12} sm={12} md={2} lg={2} className="flex flex-row justify-start align-middle filter-input-container">
            <SearchInput
              label="Grupo"
              category="grupo"
              value={grupo}
              selectValues={grupos}
              valueKey="dsGrupoInmueble"
              idKey="grupoInmuebleId"
              handleFilterSelected={handleFilterSelected}
            />
          </Grid>

          <Grid item xs={12} sm={12} md={2} lg={2} className="flex flex-row justify-start align-middle filter-input-container">
            <SearchInput
              label="Inmueble"
              category="inmueble"
              value={inmueble}
              selectValues={inmuebles}
              valueKey="dsInmueble"
              idKey="inmuebleId"
              handleFilterSelected={handleFilterSelected}
            />
          </Grid>
          <Grid item xs={12} sm={12} md={2} lg={2} className="flex flex-row justify-start align-middle filter-input-container">
            <SearchInput
              label="Nodo"
              category="nodo"
              value={nodo}
              selectValues={nodos}
              valueKey="dsNodo"
              idKey="nodeId"
              handleFilterSelected={handleFilterSelected}
            />
          </Grid>
        </>
      )}
      <Grid item xs={12} sm={6} md={2} lg={2} className="flex flex-row justify-start align-middle"/>
      <Grid item xs={12} sm={12} md={3} lg={3} className="filter-buttons-container" sx={{ alignItems: 'center' }}>
        <Button variant="outlined" style={{ borderRadius: '8px', fontSize: '12px' }} onClick={handleApplyFilters}>
          Aplicar Filtros
        </Button>
        <Button
          aria-label="clear-filters"
          variant="outlined"
          style={{ borderRadius: '8px', fontSize: '12px' }}
          onClick={handleClearFilters}
        >
          Limpiar Filtros
        </Button>
        <Button variant="outlined" style={{ borderRadius: '8px', fontSize: '12px' }} startIcon={<WatchIcon />} onClick={fetchAllData}>
          Actualizar
        </Button>
      </Grid>
    </Grid>
  );
};

export default DashboardFilter;
